import { getSearchParams } from "../../../utils/request";
import { api } from "../../api";

const organizationsApi = api.injectEndpoints({
  tagTypes: ["Organizations"],
  endpoints: (builder) => ({
    getOrganizations: builder.query({
      query: (params = {}) => {
        const query = getSearchParams(params);
        return `organizations?${query}`;
      },
      transformResponse: (response) => response?.data || [],
      providesTags: (organizations) =>
        organizations
          ? [
              ...organizations.map(({ _id }) => ({
                type: "Organizations",
                id: _id,
              })),
              { type: "Organizations", id: "LIST" },
            ]
          : [{ type: "Organizations", id: "LIST" }],
    }),

    getOrganization: builder.query({
      query: ({ id, ...rest }) =>
        `organizations/${id}?${getSearchParams(rest)}`,
      transformResponse: (response) => response?.data,
      providesTags: (_result, _error, data) => [
        { type: "Organizations", id: data.id },
      ],
    }),

    createOrganization: builder.mutation({
      query(body) {
        return {
          url: "organizations",
          method: "POST",
          body,
        };
      },
      invalidatesTags: [{ type: "Organizations", id: "LIST" }],
    }),

    updateOrganization: builder.mutation({
      query({ id, data }) {
        return {
          url: `/organizations/${id}`,
          method: "PUT",
          body: data,
        };
      },
      invalidatesTags: (_result, _error, { id }) => [
        { type: "Organizations", id },
        { type: "Organizations", id: "LIST" },
      ],
    }),

    deleteOrganization: builder.mutation({
      query({ id }) {
        return {
          url: `/organizations/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: [{ type: "Organizations", id: "LIST" }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetOrganizationsQuery,
  useGetOrganizationQuery,
  useCreateOrganizationMutation,
  useUpdateOrganizationMutation,
  useDeleteOrganizationMutation,
} = organizationsApi;










